import React from 'react'
import Loadable from '../../../components/loadable/Loadable'
import EnableTwoFA from './enabletwofa/EnableTwoFA'
import { componentKey as AuthenticationComponentKey } from '../../authentication/AuthenticationSlice'
import { useSelector } from 'react-redux'
import { componentKey } from './TwoFactorAuthenticationSlice'
import styles from "./TwoFactorAuthentication.styles"

export default function TwoFactorAuthentication() {
	const {twoFAEnabled} = useSelector(state => state[AuthenticationComponentKey])
	const {loadingState} = useSelector(state => state[componentKey])
	
	return (
		<div style={styles.TFA_mainContainer}>
			{
				<EnableTwoFA />
			}
		</div>
	)
}